import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CalendarDateFormatter, CalendarEvent, CalendarEventTitleFormatter, CalendarView, DAYS_OF_WEEK } from 'angular-calendar';
import moment from 'moment';
import { Subject } from 'rxjs';
import { DateService } from '../services/date.service';
import { CustomDateFormatter } from './custom-date-formatter';
import { CustomEventTitleFormatter } from './custom-event-title-formatter';

moment.updateLocale('fr', {
  week: {
    dow: DAYS_OF_WEEK.MONDAY,
    doy: 0,
  },
});

@Component({
  selector: 'app-calendar',
  templateUrl: './calendar.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    {
      provide: CalendarDateFormatter,
      useClass: CustomDateFormatter,
    },
    {
      provide: CalendarEventTitleFormatter,
      useClass: CustomEventTitleFormatter,
    },
  ],
})
export class CalendarComponent implements OnInit {
  public calendarView = CalendarView;
  public viewDate: Date;
  public view: CalendarView = CalendarView.Week;
  public title: string;
  public refresh = new Subject<void>();
  public today: Date;
  public isToday: boolean = true;
  @Input() public events: CalendarEvent[] = [];
  @Output() public dateChange: EventEmitter<Date> = new EventEmitter<Date>();
  @Output() public selectedEventId: EventEmitter<number> = new EventEmitter<number>();

  constructor(private readonly dateService: DateService) {}

  public ngOnInit(): void {
    this.today = this.dateService.getCurrent();
    this.viewDate = this.today;
    this.emitDateChange();
  }

  public handleEvent(action: string, event: CalendarEvent): void {
    if (action === 'Clicked') {
      this.selectedEventId.emit(+event.id);
    }
  }

  public dayClicked({ date }: { date: Date }): void {
    this.viewDate = date;
    this.view = CalendarView.Day;
  }

  public setView(view: CalendarView) {
    this.view = view;
    this.checkIfToday();
  }

  public emitDateChange() {
    this.checkIfToday();
    this.dateChange.emit(this.viewDate);
  }

  private checkIfToday() {
    if (
      (this.view === CalendarView.Month && moment(this.viewDate).isSame(this.today, 'month')) ||
      (this.view === CalendarView.Week && moment(this.viewDate).isSame(this.today, 'week')) ||
      (this.view === CalendarView.Day && moment(this.viewDate).isSame(this.today, 'day'))
    ) {
      this.isToday = true;
    } else {
      this.isToday = false;
    }
  }
}
